<template>
  <button :class="mode">
    <slot></slot>
  </button>
</template>

<script>
export default {
  props: {
    link: {
      type: Boolean,
      required: false,
      default: false,
    },
    to: {
      type: String,
      required: false,
      default: "/",
    },
    mode: {
      type: String,
      required: false,
      default: null,
    },
  },
};
</script>

<style scoped>
button {
  background: var(--orange);
  color: white;
  border: 1px solid #676767; 
  border-radius: 8px;  
  cursor: pointer;
  transition: 0.2s;
}

button:hover {
  background: var(--orange-dark);
}
</style>
